<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useSidebar } from 'dashboard/composables/useSidebar';
import Button from 'dashboard/components-next/button/Button.vue';

const route = useRoute();
const { toggleSidebar, openMobile } = useSidebar();

const isConversationRoute = computed(() => {
  const CONVERSATION_ROUTES = [
    'inbox_conversation',
    'conversation_through_inbox',
    'conversations_through_label',
    'team_conversations_through_label',
    'conversations_through_folders',
    'conversation_through_mentions',
    'conversation_through_unattended',
    'conversation_through_participating',
    'inbox_view_conversation',
  ];
  return CONVERSATION_ROUTES.includes(route.name);
});
</script>

<template>
  <div
    v-if="!isConversationRoute"
    id="mobile-sidebar-launcher"
    class="fixed bottom-4 ltr:left-4 rtl:right-4 z-40 transition-transform duration-200 ease-in-out block md:hidden"
    :class="[
      {
        'ltr:translate-x-48 rtl:-translate-x-48': openMobile,
      },
    ]"
  >
    <div class="rounded-full bg-n-alpha-2 p-1">
      <Button
        icon="i-lucide-menu"
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl"
        lg
        @click="toggleSidebar"
      />
    </div>
  </div>
  <template v-else />
</template>
